module.exports = __webpack_public_path__ + "img/loading.a8b3fd3b.gif";